// extracted by mini-css-extract-plugin
module.exports = {"devFeatureLocalOverrides":"_2OgvBV-k","toggle":"Vxy3_XFS","list":"_3w8Ue1VC","item":"_1ZwJSull","name":"Q9BVsU47","input":"zjK21sZo","deinit":"_171yLU2B"};